import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {BonusBunniesGameAssets} from "../BonusBunniesGameAssets";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunnies} from "../BonusBunnies";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

/**
 * Created by Jerker Nord on 2020-03-25.
 */

export class BonusBunniesIntroStartPage extends SlideShowPage {

    private _multiplierText:PIXI.Text;
    private _winUpToText:PIXI.Text;
    private _betsText:PIXI.Text;

    constructor() {
        super(undefined, undefined, 0x432215);

        const winUpToStyle = new PIXI.TextStyle({
            fill : 0xff0000,
            fontFamily : "Open Sans",
            fontWeight : "bolder",
            wordWrap : true,
            padding : 20,
            wordWrapWidth : 420,
            fontSize : 20,
            breakWords : true,
            stroke : "#000000",
            strokeThickness : 2
        });

        const multiplierStyle:PIXI.TextStyle = new PIXI.TextStyle({
            fill : 0xff6c00,
            fontFamily : "Open Sans",
            fontWeight : "bolder",
            wordWrap : true,
            padding : 20,
            wordWrapWidth : 420,
            fontSize : 30,
            breakWords : true,
            stroke : "#000000",
            strokeThickness : 2
        });

        const singleFeatureImg:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(BonusBunniesGameAssets.INTRO_FEATURE_1));
        singleFeatureImg.anchor.set(0.5, 0.5);
        singleFeatureImg.position.set(-235, -5);
        this.addChild(singleFeatureImg);

        const doubleFeatureImg:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture(BonusBunniesGameAssets.INTRO_FEATURE_ALL));
        doubleFeatureImg.anchor.set(0.5, 0.5);
        doubleFeatureImg.position.set(130, 4);
        this.addChild(doubleFeatureImg);

        const winUpToTextContainer:PIXI.Container = new PIXI.Container();
        winUpToTextContainer.position.set(0, -173);
        if (BonusBunnies.api.gameClientConfiguration.isSet) {
            if (BonusBunnies.api.gameClientConfiguration.showLowProbabilityGfx!==false) {
                this.addChild(winUpToTextContainer);
            }
        } else {
            BonusBunnies.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (BonusBunnies.api.gameClientConfiguration.showLowProbabilityGfx!==false) {
                    this.addChild(winUpToTextContainer);
                }
            });
        }


        this._winUpToText = new PIXI.Text(SlotGame.api.translations.translate("Win more than"), winUpToStyle);
        this._winUpToText.position.set(-86, 0);
        winUpToTextContainer.addChild(this._winUpToText);

        this._multiplierText = new PIXI.Text(SlotGame.api.translations.translate("6900x"), multiplierStyle);
        this._multiplierText.position.set(((this._winUpToText.position.x + this._winUpToText.width) + 10), -12);
        winUpToTextContainer.addChild(this._multiplierText);

        this._betsText = new PIXI.Text(SlotGame.api.translations.translate("bet"), winUpToStyle);
        this._betsText .position.set(((this._multiplierText.position.x + this._multiplierText.width) + 10), 0);
        winUpToTextContainer.addChild(this._betsText );

        winUpToTextContainer.position.x = 100 - (winUpToTextContainer.width / 2);
    }

    protected start(): void{
        this._winUpToText.position.set(-86, 0);
        this._multiplierText.position.set(((this._winUpToText.position.x + this._winUpToText.width) + 10), -12);
        this._betsText .position.set(((this._multiplierText.position.x + this._multiplierText.width) + 10), 0);
        super.start();
    }
}
